import { lazy } from "react";

export const PatientDetailsAsync = lazy(() => import("./PatientDetails"));
